/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobileApp
 */
export interface MobileApp {
    /**
     * 
     * @type {string}
     * @memberof MobileApp
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof MobileApp
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof MobileApp
     */
    link: string;
    /**
     * 
     * @type {Date}
     * @memberof MobileApp
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MobileApp
     */
    packageName: string;
    /**
     * 
     * @type {string}
     * @memberof MobileApp
     */
    appName: string;
    /**
     * 
     * @type {string}
     * @memberof MobileApp
     */
    versionName: string;
    /**
     * 
     * @type {number}
     * @memberof MobileApp
     */
    versionCode: number;
}

export function MobileAppFromJSON(json: any): MobileApp {
    return MobileAppFromJSONTyped(json, false);
}

export function MobileAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileApp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'link': json['link'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'packageName': json['package_name'],
        'appName': json['app_name'],
        'versionName': json['version_name'],
        'versionCode': json['version_code'],
    };
}

export function MobileAppToJSON(value?: MobileApp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'link': value.link,
        'package_name': value.packageName,
        'app_name': value.appName,
        'version_name': value.versionName,
        'version_code': value.versionCode,
    };
}


